import { render, staticRenderFns } from "./ChatDistributionsByAnswer.vue?vue&type=template&id=64999ab2&scoped=true"
import script from "./ChatDistributionsByAnswer.vue?vue&type=script&lang=js"
export * from "./ChatDistributionsByAnswer.vue?vue&type=script&lang=js"
import style0 from "./ChatDistributionsByAnswer.vue?vue&type=style&index=0&id=64999ab2&prod&lang=scss"
import style1 from "./ChatDistributionsByAnswer.vue?vue&type=style&index=1&id=64999ab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64999ab2",
  null
  
)

export default component.exports